import * as Sentry from '@sentry/react';
import { SeverityLevel } from '@sentry/types';
import { PayloadAction } from '@reduxjs/toolkit/src/createAction';
import { RootState } from 'Douleutaras/redux/store';
import { ignoreErrors } from 'Douleutaras/configuration/Sentry';

export const CaptureException = (err: Error, action?: PayloadAction, state?: RootState) => {
  if (ignoreErrors.some(v => err.message.includes(v))) {
    return;
  }

  Sentry.captureException(err, {
    extra: {
      action,
      state
    }
  });
};

export const CaptureMessage = (message: string) => {
  Sentry.captureMessage(message);
};

export const CaptureEvent = (message: string, myObject: {}, level: SeverityLevel = 'info') => {
  Sentry.captureEvent({
    message,
    level,
    extra: {
      data: myObject
    }
  });
};
